import { LayerHandleV2, ShimBackgroundTypeV2 } from '@volkswagen-onehub/layer-manager';
import React from 'react';
import { PortalContext } from '../../../context/PortalContext';
import { ServiceLayer } from './services-layer-types';
import { LayerComponent } from './layer-component';
import { Vehicle, GetPersonUser } from '@esportal/portal-service';

export const ServicesDetailayer: React.FC<{
	servicesLayerData: { isVisible: boolean; data: ServiceLayer };
	setServicesLayerData: React.Dispatch<React.SetStateAction<{ isVisible: boolean; data: ServiceLayer }>>;
	vehicle: Vehicle;
	servicesLayerRef: React.RefObject<LayerHandleV2<any>>;
	userData: GetPersonUser;
}> = ({ servicesLayerData, setServicesLayerData, servicesLayerRef, vehicle, userData }) => {
	const { layerManager } = React.useContext(PortalContext);
	const portalContext = React.useContext(PortalContext);

	const handleClose = () => {
		setServicesLayerData((prev) => ({ ...prev, isVisible: false }));

		if (servicesLayerRef?.current) {
			servicesLayerRef?.current.close();
			return ((servicesLayerRef.current as any) = null);
		}
		return null;
	};

	const renderJourneyLayer = () => {
		return (
			<PortalContext.Provider value={portalContext}>
				<LayerComponent servicesLayerData={servicesLayerData} vehicle={vehicle} userData={userData} />
			</PortalContext.Provider>
		);
	};

	const renderInteractionLayer = (): any => {
		if (!servicesLayerRef.current && servicesLayerData.isVisible) {
			const layer = layerManager.openContentLayerV2(
				renderJourneyLayer,
				{},
				{
					shimBackgroundType: ShimBackgroundTypeV2.OPAQUE,
					closeButtonLabel: 'Close services layer',
					contentHeadline: servicesLayerData.data.header,
					onClose: handleClose,
				},
			);
			(servicesLayerRef.current as any) = layer;
		}
		return null;
	};

	return <>{servicesLayerData.isVisible && renderInteractionLayer()}</>;
};
